import React from 'react'
import { CircularProgress } from '@material-ui/core';
import AccountResumeTable from './AccountResumeTable/AccountResumeTable';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { useTranslation } from 'react-i18next';

function AccountResume(props) {

    let {Account} = props

    const { t } = useTranslation()
    
    if (Account === null) {
        return (
            <div className="analysisCard" style={{minHeight: "250px"}}>
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("account_summary")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <CircularProgress style={{margin:"auto"}} />
                </div>
            </div>
        );    
    }
    else if (Account === undefined){
        return (
            <div className="analysisCard" style={{minHeight: "250px"}}>
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("account_summary")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                        {t("information_unavailable")}
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="analysisCard">
            <div style={{display: "flex"}}>
                <FormatListBulletedIcon className={"blueText"}/>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t("account_summary")}</span>
            </div>
            <div className="internalCardContainer">
                <div>
                    <div>
                        <AccountResumeTable account={Account}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountResume